import {
  SET_HEADER_TITLE,
} from '../types';

const setHeaderTitle = title => ({
  type: SET_HEADER_TITLE,
  payload: {
    title,
  },
});

export default {
  setHeaderTitle,
};



// WEBPACK FOOTER //
// ./src/state/actions/header.js